var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8246 10.7875V10.8248H12.8006C12.8085 10.8125 12.8165 10.8 12.8246 10.7875Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.71921C0 0.769971 0.789018 0 1.76237 0H22.0863C23.0596 0 23.8487 0.769971 23.8487 1.71921V22.2808C23.8487 23.2303 23.0596 24 22.0863 24H1.76237C0.789018 24 0 23.2303 0 22.2808V1.71921ZM7.22927 20.0905V9.25314H3.62714V20.0905H7.22927ZM5.42819 7.77349C6.68433 7.77349 7.46617 6.9413 7.46617 5.90131C7.44276 4.8379 6.68433 4.02881 5.45202 4.02881C4.21984 4.02881 3.4142 4.8379 3.4142 5.90131C3.4142 6.9413 4.19588 7.77349 5.40471 7.77349H5.42819ZM12.8245 20.0905H9.22244C9.22244 20.0905 9.2698 10.27 9.22253 9.25314H12.8246V10.7875C13.3033 10.049 14.1601 8.99884 16.0709 8.99884C18.4408 8.99884 20.2179 10.5478 20.2179 13.8765V20.0905H16.6161V14.2928C16.6161 12.8359 16.0947 11.8421 14.7913 11.8421C13.7962 11.8421 13.2035 12.5123 12.9431 13.1594C12.8479 13.391 12.8245 13.7146 12.8245 14.0385V20.0905Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLinkIcon);
export default __webpack_public_path__ + "static/media/linkedIn-link-icon.354f9a214b7958135042113003cb4d8a.svg";
export { ForwardRef as ReactComponent };